export const msalConfig = {
    auth: {
        clientId: '', // Replace with your client ID
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: 'http://localhost:3000', // Replace with your redirect URI
    }
};